import { useRef } from "react";
import { makeStyles } from "@mui/styles";
import {
  TextField,
  Button,
  FormControl,
  RadioGroup,
  FormControlLabel,
  Radio,
  FormHelperText,
  IconButton,
} from "@mui/material";
import CameraAltOutlinedIcon from "@mui/icons-material/CameraAltOutlined";
import ImageIcon from "@mui/icons-material/Image";
import DeleteIcon from "@mui/icons-material/Delete";
import { useLanguageContext } from "../../../Context/LanguageContext";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    padding: theme.spacing(2),
    borderTop: `1px solid ${theme.palette.divider}`,
  },
  navigation: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    width: "100%",
    marginBottom: theme.spacing(1),
  },
  timeline: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    width: "50%",
  },
  timelineStep: {
    width: "33.33%",
    height: "4px",
    backgroundColor: theme.palette.primary.main,
    borderRadius: "2px",
    transition: "background-color 0.3s ease",
  },
  activeStep: {
    backgroundColor: theme.palette.secondary.main,
  },

  fileInput: {
    display: "none",
  },
  formHelperText: {
    fontSize: 14,
  },
}));

export default function QuestionType({
  question,
  questionNo,
  onFieldChange,
  handleBlurChanges,
  isDisable,
  handleButtonStatusChange,
  fileHandler,
  handleImagePopover,
  _key,
  handleCreateTicketCheckbox,
  showCanCreateTicketCheckbox,
  handleQuestionImageChange,
}) {
  const classes = useStyles();
  const { localization } = useLanguageContext();
  const fileInputRef = useRef(null);
  const questionImageInputRef = useRef(null);

  const handleChange = (event, _value) => {
    onFieldChange(
      _value,

      questionNo - 1,
    );
  };

  const handletextChanges = (event, _value, key) => {
    const _temp = question["value"]["first"] === "" ? _value.trim() : _value;
    onFieldChange(
      _temp,

      questionNo - 1,
    );
  };

  const handleButtonClick = () => {
    fileInputRef.current.click();
  };

  const handleBlur = (event, _value) => {
    if (question.isMandatory) {
      if (_value === "" && !question.error) {
        handleBlurChanges(true, _value, null, questionNo - 1);
      } else if (question.error && _value !== "") {
        handleBlurChanges(false, _value, null, questionNo - 1);
      }
    }
  };

  const handleButtonSelection = (_value) => {
    handleButtonStatusChange(questionNo - 1, _value);
  };

  const handleFileChanges = (event) => {
    const files = Array.from(event.target.files).filter((file) =>
      file.type.startsWith("image/"),
    );

    let tempFileArray = files.map((file, index) => ({
      Filename: file.name,
      Filecontent: URL.createObjectURL(file),
      Filetyp: file.type,
      FileContentBytes: null,
    }));

    if (question.value !== "") {
      tempFileArray = [...question.value, ...tempFileArray];
    }
    fileHandler(questionNo - 1, tempFileArray.length > 0 ? tempFileArray : "");
  };

  const handleQuestionImageButtonClick = () => {
    questionImageInputRef.current.click();
  };

  const handleQuestionImageFileChanges = (event) => {
    const files = Array.from(event.target.files).filter((file) =>
      file.type.startsWith("image/"),
    );

    let tempFileArray = [];

    if (files && files.length > 0) {
      files.forEach((file) => {
        const reader = new FileReader();
        reader.onload = () => {
          tempFileArray.push({
            Filename: file.name,
            Filecontent: reader.result,
            Filetyp: file.type,
            FileContentBytes: null,
          });

          if (handleQuestionImageChange) {
            handleQuestionImageChange(questionNo - 1, tempFileArray[0]);
          }
        };
        reader.onerror = () => {};
        reader.readAsDataURL(file);
      });
    }
  };

  const handleDeleteQuestionImage = () => {
    if (handleQuestionImageChange) {
      handleQuestionImageChange(questionNo - 1, null);
    }
  };

  const expectedResultDiv = (_error, _expectedResult) => {
    const _render = _expectedResult ? (
      <div className="row ml-4 mr-0 mt-2" key={_key + questionNo + 1}>
        <FormHelperText className={classes.formHelperText}>
          <span className="styleExpectedLabel">
            {localization.expectedResult + ":"}
          </span>
          <span className="styleExpectedvalue"> {_expectedResult}</span>
        </FormHelperText>
      </div>
    ) : (
      <></>
    );
    return _render;
  };
  const renderInputBasedOnType = () => {
    switch (question.answerType.toLowerCase()) {
      case "text":
        return (
          <>
            <TextField
              className="mb-3 mr-3"
              fullWidth
              value={question.value["first"]}
              helperText={question.error && question.errorMessage["first"]}
              variant="outlined"
              disabled={isDisable}
              onChange={(e) => {
                handletextChanges(e, e.target.value, null);
              }}
              onBlur={(e) => {
                handleBlur(e, e.target.value, null);
              }}
              error={question.error}
            />

            {expectedResultDiv(question.error, question?.expectedResult)}
          </>
        );
      case "number":
        return (
          <>
            <TextField
              className="mb-3 mr-3"
              fullWidth
              type="number"
              value={question.value["first"]}
              helperText={question.error && question.errorMessage["first"]}
              variant="outlined"
              disabled={isDisable}
              onChange={(e) => {
                handletextChanges(e, e.target.value, null);
              }}
              onBlur={(e) => {
                handleBlur(e, e.target.value, null);
              }}
              error={question.error}
            />
            {expectedResultDiv(question.error, question?.expectedResult)}
          </>
        );
      case "description":
        return (
          <>
            <TextField
              className="mb-3 mr-3"
              fullWidth
              multiline
              rows={4}
              value={question.value["first"]}
              helperText={question.error && question.errorMessage["first"]}
              variant="outlined"
              disabled={isDisable}
              onChange={(e) => {
                handletextChanges(e, e.target.value, null);
              }}
              onBlur={(e) => {
                handleBlur(e, e.target.value, null);
              }}
              error={question.error}
            />
            {expectedResultDiv(question.error, question?.expectedResult)}
          </>
        );
      case "yes/no":
        return (
          <>
            <div className="row w-100 ml-0 mr-0">
              <div className="col mt-2">
                <Button
                  disabled={isDisable}
                  variant="contained"
                  className={`buttonRounded w-100  ${
                    question.value === "J" ? "selectButton" : "notSelected"
                  }`}
                  onClick={(e) => {
                    e.preventDefault();

                    handleChange(e, "J");
                  }}
                >
                  {localization.yes}
                </Button>
              </div>
              <div className="col mt-2">
                <Button
                  disabled={isDisable}
                  variant="contained"
                  className={`buttonRounded w-100  ${
                    question.value === "N" ? "selectButtonyes" : "notSelected"
                  }`}
                  onClick={(e) => {
                    e.preventDefault();

                    handleChange(e, "N");
                  }}
                >
                  {localization.no}
                </Button>
              </div>
            </div>

            <div className="row ml-0 mr-0 mt-2">
              <div className="col mt-2 errorCls">
                {question.error ? localization.selectoptionDropDown : ""}
              </div>
            </div>
            {expectedResultDiv(question.error, question?.expectedResult)}
          </>
        );
      case "objective":
        return (
          <FormControl
            component="fieldset"
            className="w-100"
            error={question.error}
          >
            <RadioGroup
              aria-label="objective-options"
              name={`objective-${question.id}`}
              value={question.value["first"]}
              onChange={(e) => handletextChanges(e, e.target.value, null)}
              onBlur={(e) => {
                handleBlur(e, e.target.value, null);
              }}
            >
              {question.optionlist.map((option, index) => (
                <FormControlLabel
                  className="ml-0 mr-0 w-100"
                  key={index}
                  value={option}
                  control={<Radio />}
                  label={option}
                  disabled={isDisable}
                />
              ))}
            </RadioGroup>
            {question.error && (
              <FormHelperText style={{ color: "red" }}>
                {question.errorMessage["first"]}
              </FormHelperText>
            )}
            <div className="row w-100 ml-0 mr-0">
              <div className="col mt-2">
                <Button
                  disabled={isDisable}
                  variant="contained"
                  className={`buttonRounded w-100  ${
                    question.value["second"] === "yes" ? "selectButtonyes" : ""
                  }`}
                  onClick={(e) => {
                    e.preventDefault();

                    if (question.errorMessage["second"] === "") {
                      handleButtonSelection("yes");
                    } else {
                      handletextChanges(e, "yes", "button");
                    }
                  }}
                >
                  {localization.yes}
                </Button>
              </div>
              <div className="col mt-2">
                <Button
                  disabled={isDisable}
                  variant="contained"
                  className={`buttonRounded w-100  ${
                    question.value["second"] === "no" ? "selectButton" : ""
                  }`}
                  onClick={(e) => {
                    e.preventDefault();

                    if (question.errorMessage["second"] === "") {
                      handleButtonSelection("no");
                    } else {
                      handletextChanges(e, "no", "button");
                    }
                  }}
                >
                  {localization.no}
                </Button>
              </div>
            </div>
            <div className="row ml-0 mr-0 mt-2">
              {question.errorMessage["second"] && (
                <div className="col mt-2 errorCls">
                  {question.errorMessage["second"]}
                </div>
              )}
            </div>
          </FormControl>
        );
      case "dropdownoption":
        return (
          <>
            <div className="row w-100 m-0">
              <TextField
                select
                SelectProps={{
                  native: true,
                }}
                className="mb-3 mr-3"
                fullWidth
                value={question.value["first"]}
                helperText={question.error && question.errorMessage["first"]}
                variant="outlined"
                disabled={isDisable}
                onChange={(e) => {
                  handleChange(e, e.target.value, null);
                }}
                onBlur={(e) => {
                  handleBlur(e, e.target.value, null);
                }}
                error={question.error}
              >
                <option value="">{localization.select}</option>
                {question.dropdownOption?.split(";").map((opt, index) => {
                  return (
                    <option key={index} value={opt}>
                      {opt}
                    </option>
                  );
                })}
              </TextField>
            </div>
            <div className="row">
              {expectedResultDiv(question.error, question?.expectedResult)}
            </div>
          </>
        );
      case "radiooption":
        return (
          <>
            <div className="row w-100 m-0">
              <FormControl>
                <RadioGroup
                  aria-labelledby="demo-controlled-radio-buttons-group"
                  name="controlled-radio-buttons-group"
                  value={question.value["first"]}
                  onChange={(e) => {
                    handleChange(e, e.target.value, null);
                  }}
                  onBlur={(e) => {
                    handleBlur(e, e.target.value, null);
                  }}
                  error={question.error}
                >
                  {question.radioOption.split(";").map((opt, index) => {
                    if (opt.trim() != "") {
                      return (
                        <FormControlLabel
                          key={index}
                          value={opt}
                          control={<Radio />}
                          label={opt}
                        />
                      );
                    }
                  })}
                </RadioGroup>
                {question.error && (
                  <FormHelperText style={{ color: "red", fontSize: "14px" }}>
                    {question.errorMessage["first"]}
                  </FormHelperText>
                )}
              </FormControl>
            </div>
            <div className="row">
              {expectedResultDiv(question.error, question?.expectedResult)}
            </div>
          </>
        );
      case "rangevalue":
        return (
          <>
            <TextField
              className="mb-3 mr-3"
              fullWidth
              type="number"
              value={question.value["first"]}
              helperText={question.error && question.errorMessage["first"]}
              variant="outlined"
              disabled={isDisable}
              onChange={(e) => {
                handletextChanges(e, e.target.value, null);
              }}
              onBlur={(e) => {
                handleBlur(e, e.target.value, null);
              }}
              error={question.error}
            />
            <div className="row d-block ml-3">
              <p>
                {localization.minValue}: {question.rangeValue["min"]}
              </p>
              <p>
                {localization.maxValue}: {question.rangeValue["max"]}
              </p>
            </div>
          </>
        );
      case "picture":
        return (
          <div className="col ">
            <div className="row">
              {question.value !== "" && (
                <IconButton
                  onClick={() => handleImagePopover(true, questionNo - 1)}
                >
                  <ImageIcon />
                </IconButton>
              )}
              <input
                type="file"
                ref={fileInputRef}
                className={classes.fileInput}
                onChange={handleFileChanges}
                multiple
              />

              <Button
                variant="contained"
                className={"buttonRounded w-100 imageButton"}
                onClick={handleButtonClick}
              >
                {localization.takePicture}
                <CameraAltOutlinedIcon className="ml-2" />
              </Button>
            </div>
            {question["error"] && (
              <div className="row ml-4 mr-0 mt-2">
                <FormHelperText style={{ color: "red", fontSize: "14px" }}>
                  {question["errorMessage"]}
                </FormHelperText>
              </div>
            )}
          </div>
        );
      default:
        return null;
    }
  };

  return (
    <div className="mb-5" key={_key}>
      <div className="row mb-2 mr-3 ml-3 questionStyle">
        <strong>{questionNo}.</strong> {question.frage}
        {question.isMandatory && <span className="questionAsteric"> *</span>}
      </div>

      <div className="row w-100 mr-3 ml-3">{renderInputBasedOnType()}</div>

      <div className="row w-100 mr-3 ml-3 mt-4">
        <div className="col">
          <label className="form-label mb-2" htmlFor="">
            {!isDisable && (
              <>
                {localization.addImageForQuestion || "Add Image for Question"}{" "}
                <span style={{ fontSize: "0.8em", color: "gray" }}>
                  ({localization.optional || "Optional"})
                </span>
              </>
            )}

            {isDisable && question.questionImage && (
              <>{localization.image || "Image"}</>
            )}
          </label>
          <div className="d-flex align-items-center">
            {question.questionImage && (
              <>
                <span style={{ marginRight: "10px", fontWeight: "500" }}>
                  {question.questionImage.Filename}
                </span>
                {!isDisable && (
                  <IconButton
                    onClick={handleDeleteQuestionImage}
                    size="small"
                    title={localization.delete}
                  >
                    <DeleteIcon fontSize="small" />
                  </IconButton>
                )}
              </>
            )}
            {!question.questionImage && !isDisable && (
              <>
                <input
                  type="file"
                  ref={questionImageInputRef}
                  className={classes.fileInput}
                  onChange={handleQuestionImageFileChanges}
                  accept="image/*"
                />
                <Button
                  variant="contained"
                  className={"buttonRounded imageButton"}
                  onClick={handleQuestionImageButtonClick}
                  size="small"
                >
                  {localization.uploadImage || "Upload Image"}
                  <CameraAltOutlinedIcon
                    className="ml-2"
                    style={{ fontSize: "1rem" }}
                  />
                </Button>
              </>
            )}
          </div>
        </div>
      </div>

      {question.canCreateTicket && showCanCreateTicketCheckbox && (
        <div className="form-group w-100 d-flex ml-3 align-items-center">
          <div className="pl-0">
            <label className=" form-label" htmlFor="">
              {localization.createTicket}
            </label>
          </div>
          <div className="pl-3">
            <input
              type="checkbox"
              name=""
              checked={question.createTicket}
              onChange={(e) => {
                handleCreateTicketCheckbox(question.id);
              }}
            />
          </div>
        </div>
      )}
    </div>
  );
}
